import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { VisitorScanRegistrationQRCodeComponent } from './component/visitor-scan-registration-qrcode.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { CommonLayoutModule } from '@sdbn/common';



@NgModule({
  declarations: [
    VisitorScanRegistrationQRCodeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonLayoutModule,
    DictionaryModule,
    CommonTranslationModule,
    ZXingScannerModule
  ]
})
export class VisitorScanRegistrationQRCodeModule { }
